import { LandingContent } from "./LandingContent";

export const LandingPage = () => {
  return <LandingContent />;
};
